export default __webpack_public_path__ + "static/images/download-banner/splash.png";